import type { GameEvent } from "@/types"

export const kazdelEvents: Record<string, GameEvent> = {
    "dlg-kz-w": {
        id: "dlg-kz-w",
        type: "dialog",
        dialogues: [
            {
                speaker: "map.speaker.w",
                expression: "normal",
                side: "left",
                text: "map.dialog.kzW.d1",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "right",
                text: "map.dialog.kzW.d2",
            },
            {
                speaker: "map.speaker.w",
                expression: "disdain",
                side: "left",
                text: "map.dialog.kzW.d3",
            },
            {
                speaker: "map.speaker.amiya",
                expression: "normal",
                side: "right",
                text: "map.dialog.kzW.d4",
            },
            {
                speaker: "map.speaker.amiya",
                expression: "normal",
                side: "right",
                text: "map.dialog.kzW.d5",
            },
            {
                speaker: "map.speaker.w",
                expression: "normal",
                side: "left",
                text: "map.dialog.kzW.d6",
            },
            {
                speaker: "map.speaker.w",
                expression: "normal",
                side: "left",
                text: "map.dialog.kzW.d7",
            },
        ],
        choices: [],
    },

    "dlg-kz-odda": {
        id: "dlg-kz-odda",
        type: "dialog",
        dialogues: [
            {
                speaker: "map.speaker.doctor",
                expression: "confused",
                side: "left",
                text: "map.dialog.kzOdda.d1",
            },
            {
                speaker: "map.speaker.odda",
                expression: "normal",
                side: "right",
                text: "map.dialog.kzOdda.d2",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "confused",
                side: "left",
                text: "map.dialog.kzOdda.d3",
            },
            {
                speaker: "map.speaker.odda",
                expression: "normal",
                side: "right",
                text: "map.dialog.kzOdda.d4",
            },
            {
                speaker: "map.speaker.odda",
                expression: "thinking",
                side: "right",
                text: "map.dialog.kzOdda.d5",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "thinking",
                side: "left",
                text: "map.dialog.kzOdda.d6",
            },
            {
                speaker: "map.speaker.savage",
                expression: "happy",
                side: "left",
                text: "map.dialog.kzOdda.d7",
            },
            {
                speaker: "map.speaker.odda",
                expression: "normal",
                side: "right",
                text: "map.dialog.kzOdda.d8",
            },
        ],
        choices: [],
    },

    "evt-kz-01": {
        id: "evt-kz-01",
        type: "event",
        description: "map.event.kz01.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.kz01.c1",
                resultText: "map.event.kz01.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "thinking",
                        text: "map.event.kz01.c1d",
                    },
                ],
            },
        ],
    },

    "evt-kz-02": {
        id: "evt-kz-02",
        type: "event",
        description: "map.event.kz02.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.kz02.c1",
                resultText: "map.event.kz02.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.savage",
                        expression: "happy",
                        text: "map.event.kz02.cd",
                    },
                ],
            },
            {
                id: "c2",
                text: "map.event.kz02.c2",
                resultText: "map.event.kz02.c2r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.savage",
                        expression: "normal",
                        text: "map.event.kz02.cd",
                    },
                ],
            },
        ],
    },

    "evt-kz-03": {
        id: "evt-kz-03",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-kazdel-3.png"),
        description: "map.event.kz03.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.kz03.c1",
                resultText: "map.event.kz03.c1r",
                nextDialogues: [],
            },
            {
                id: "c2",
                text: "map.event.kz03.c2",
                resultText: "map.event.kz03.c2r",
                nextDialogues: [],
            },
        ],
        unlockGalleryId: "gal-kz-01",
    },

    "evt-kz-04": {
        id: "evt-kz-04",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-kazdel-4.png"),
        description: "map.event.kz04.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.kz04.c1",
                resultText: "map.event.kz04.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "happy",
                        text: "map.event.kz04.c1d",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-kz-02",
    },

    "evt-kz-05": {
        id: "evt-kz-05",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-kazdel-5.png"),
        description: "map.event.kz05.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.kz05.c1",
                resultText: "map.event.kz05.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.savage",
                        expression: "normal",
                        text: "map.event.kz05.c1d",
                    },
                ],
            },
            {
                id: "c2",
                text: "map.event.kz05.c2",
                resultText: "map.event.kz05.c2r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "normal",
                        text: "map.event.kz05.c2d",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-kz-03",
    },

    "evt-kz-06": {
        id: "evt-kz-06",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-kazdel-6.png"),
        description: "map.event.kz06.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.kz06.c1",
                resultText: "map.event.kz06.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.w",
                        expression: "frown",
                        text: "map.event.kz06.c1d",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-kz-04",
    },
}
